import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

const ExtraOffersListView = ({ navigate, setEditingExtraOfferId, setNewExtraOffer, loading, extraOffers, editExtraOffer, deleteExtraOffer }) => (
  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 font-sans">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-4">
          <button 
            onClick={() => navigate('/admin')} 
            className="w-fit flex items-center gap-1.5 text-black font-bold uppercase tracking-[0.2em] text-[10px] transition-all bg-gray-50 px-3 py-2 rounded-lg border border-gray-100 hover:bg-black hover:text-white"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
            </svg>
            Nazad
          </button>
          <h2 className="text-xl font-black text-black tracking-tight">Dodatne Ponude</h2>
        </div>
        
        <button 
          className="w-fit bg-black text-white px-5 py-2.5 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-gray-800 transition-all font-sans" 
          onClick={() => {
            setEditingExtraOfferId(null);
            setNewExtraOffer({ naziv: { bs: '', en: '' }, cijena: '', valuta: 'BAM' });
            navigate('add');
          }}
        >
          + Nova Stavka
        </button>
      </div>
      
      {loading ? <p className="text-black text-center py-8">Učitavanje...</p> : (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {extraOffers.length === 0 && (
            <div className="text-center py-8 text-black col-span-full">Nema dodatnih ponuda.</div>
          )}

          {extraOffers.map((item) => (
            <div key={item.firestoreId} className={`bg-white rounded-xl p-5 border transition-all hover:border-black`}>
              <div className="flex justify-between items-start mb-4">
                <div className="min-w-0">
                  <h3 className="font-black text-black text-lg leading-tight truncate">{item.naziv?.bs}</h3>
                  {item.naziv?.en && <p className="text-xs text-black mt-1">{item.naziv?.en}</p>}
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div>
                  <label className="text-[9px] font-bold text-black uppercase tracking-widest block mb-1">Cijena</label>
                  <div className="font-black text-black text-base">{item.cijena} {item.valuta}</div>
                </div>
              </div>

              <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
                <button onClick={() => editExtraOffer(item)} className="flex-1 px-3 py-2 bg-white text-black border border-gray-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-all">Uredi</button>
                <button onClick={() => deleteExtraOffer(item.firestoreId)} className="w-10 h-10 flex items-center justify-center bg-red-50 text-red-400 rounded-lg hover:bg-black hover:text-white transition-all border border-transparent">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
      )}
  </div>
);

const ExtraOffersFormView = ({ navigate, setEditingExtraOfferId, handleFormSubmitLocal, editingExtraOfferId, newExtraOffer, handleExtraOfferInputChange, autoResize }) => (
  <div className="bg-transparent max-w-2xl mx-auto font-sans">
      <div className="flex items-center gap-4 mb-8 px-4">
          <button 
              onClick={() => {
                  setEditingExtraOfferId(null);
                  navigate('/admin/extra-offers');
              }}
              className="w-fit flex items-center gap-1.5 text-black font-bold uppercase tracking-[0.2em] text-[10px] transition-all bg-gray-50 px-3 py-2 rounded-lg border border-gray-100 hover:bg-black hover:text-white"
          >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
              </svg>
              Nazad
          </button>
          <h3 className="text-xl font-black text-black tracking-tight">{editingExtraOfferId ? 'Uredi stavku' : 'Nova stavka'}</h3>
      </div>

      <form onSubmit={handleFormSubmitLocal} className="space-y-4">
        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Naziv (BS)</label>
          <div style={{ position: 'relative' }}>
            <textarea
              name="naziv.bs"
              rows="1"
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
              value={newExtraOffer.naziv?.bs || ''}
              onChange={(e) => { handleExtraOfferInputChange(e); autoResize(e); }}
              required
              placeholder="npr. Snimci dronom"
            />
          </div>
        </div>
        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Naziv (EN)</label>
          <textarea
            name="naziv.en"
            rows="1"
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            value={newExtraOffer.naziv?.en || ''}
            onChange={(e) => { handleExtraOfferInputChange(e); autoResize(e); }}
            placeholder="e.g. Drone footage"
          />
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2 form-group">
            <label className="block text-sm font-medium text-black mb-1">Cijena</label>
            <input
              name="cijena"
              value={newExtraOffer.cijena}
              onChange={handleExtraOfferInputChange}
              required
              placeholder="npr. 150"
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
          </div>
          <div className="form-group">
            <label className="block text-sm font-medium text-black mb-1">Valuta</label>
            <select 
              name="valuta" 
              value={newExtraOffer.valuta} 
              onChange={handleExtraOfferInputChange}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            >
              <option value="BAM">BAM</option>
              <option value="EUR">EUR</option>
            </select>
          </div>
        </div>

        <div className="flex gap-3 pt-4">
          <button type="submit" className="flex-[3] bg-black text-white hover:bg-gray-800 py-3 rounded-lg font-bold transition-colors shadow-sm text-[10px] uppercase tracking-[0.2em]">
              {editingExtraOfferId ? 'Spremi izmjene' : 'Dodaj stavku'}
          </button>
          <button 
              type="button" 
              onClick={() => {
                  setEditingExtraOfferId(null);
                  navigate('/admin/extra-offers');
              }} 
              className="flex-1 py-3 border border-gray-300 text-black rounded-lg font-bold hover:bg-gray-50 transition-colors text-[10px] uppercase tracking-[0.2em]"
          >
              Otkaži
          </button>
        </div>
      </form>
  </div>
);

const AdminExtraOffers = ({
  extraOffers,
  newExtraOffer,
  setNewExtraOffer,
  handleExtraOfferSubmit,
  handleExtraOfferInputChange,
  editingExtraOfferId,
  setEditingExtraOfferId,
  deleteExtraOffer,
  editExtraOffer,
  loading
}) => {
  const navigate = useNavigate();
  
  // URL Sync Effect
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/edit/') && !editingExtraOfferId && extraOffers.length > 0) {
      const idFromPath = path.split('/edit/')[1];
      const itemToEdit = extraOffers.find(o => o.firestoreId === idFromPath);
      if (itemToEdit) editExtraOffer(itemToEdit);
    }
  }, [extraOffers, editingExtraOfferId, editExtraOffer]);

  const autoResize = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  const handleFormSubmitLocal = async (e) => {
    await handleExtraOfferSubmit(e);
    navigate('/admin/extra-offers');
  };

  return (
    <Routes>
      <Route path="/" element={<ExtraOffersListView navigate={navigate} setEditingExtraOfferId={setEditingExtraOfferId} setNewExtraOffer={setNewExtraOffer} loading={loading} extraOffers={extraOffers} editExtraOffer={editExtraOffer} deleteExtraOffer={deleteExtraOffer} />} />
      <Route path="/add" element={<ExtraOffersFormView navigate={navigate} setEditingExtraOfferId={setEditingExtraOfferId} handleFormSubmitLocal={handleFormSubmitLocal} editingExtraOfferId={editingExtraOfferId} newExtraOffer={newExtraOffer} handleExtraOfferInputChange={handleExtraOfferInputChange} autoResize={autoResize} />} />
      <Route path="/edit/:id" element={<ExtraOffersFormView navigate={navigate} setEditingExtraOfferId={setEditingExtraOfferId} handleFormSubmitLocal={handleFormSubmitLocal} editingExtraOfferId={editingExtraOfferId} newExtraOffer={newExtraOffer} handleExtraOfferInputChange={handleExtraOfferInputChange} autoResize={autoResize} />} />
    </Routes>
  );
};

export default AdminExtraOffers;
